"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJController = exports.CGJAxis = exports.CGJInput = void 0;
const KHController_1 = require("./KH/Input/KHController");
var CGJInput;
(function (CGJInput) {
    CGJInput[CGJInput["GoToTarget"] = 0] = "GoToTarget";
    CGJInput[CGJInput["Pause"] = 1] = "Pause";
})(CGJInput = exports.CGJInput || (exports.CGJInput = {}));
var CGJAxis;
(function (CGJAxis) {
    CGJAxis[CGJAxis["MoveX"] = 0] = "MoveX";
    CGJAxis[CGJAxis["MoveY"] = 1] = "MoveY";
    CGJAxis[CGJAxis["TargetX"] = 2] = "TargetX";
    CGJAxis[CGJAxis["TargetY"] = 3] = "TargetY";
})(CGJAxis = exports.CGJAxis || (exports.CGJAxis = {}));
class CGJController extends KHController_1.KHController {
    constructor(inputMap, axisMap, inputSet) {
        super(inputMap, axisMap, inputSet);
    }
    getStatus() {
        return super.getStatus();
    }
    getInput(input) {
        return super.getInput(input);
    }
    getAxis(axis) {
        return super.getAxis(axis);
    }
    getIsAxisUpdated(axis) {
        return super.getIsAxisUpdated(axis);
    }
    /**
     * Injects a new input for an existing one. Useful if you want to use a
     * resettable key, for instance.
     * @param input
     * @param newInput
     */
    inject(input, newInput) {
        super.inject(input, newInput);
    }
}
exports.CGJController = CGJController;
